
















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { EmployeeModel } from '@/models/config'

// component
import FormUpdateDeviceEmployee from './FormUpdateDevice.vue'

@Component({
    name: 'ModalUpdateDeviceUser',
    components: {
        FormUpdateDeviceEmployee
    }
})
export default class ModalUpdateDeviceUser extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ required: true }) user!: EmployeeModel

    get title () {
        return 'Actualizar Dispositivos de Acceso del Usuario: ' + this.user.name
    }
}
